import React from 'react';
import { Link, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { LogOut, Package, Mail, BarChart3, TrendingUp, Type, Star, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { authService } from '@/utils/auth';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const AdminLayout = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const handleLogout = () => {
    authService.removeToken();
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', label: t('admin.dashboard'), icon: BarChart3 },
    { path: '/admin/products', label: t('admin.products'), icon: Package },
    { path: '/admin/contacts', label: t('admin.contacts'), icon: Mail },
    { path: '/admin/reviews', label: 'Отзывы', icon: Star },
    { path: '/admin/content', label: 'Контент сайта', icon: Type },
    { path: '/admin/marketing', label: 'Маркетинг', icon: TrendingUp },
  ];

  return (
    <div className="min-h-screen bg-muted" data-testid="admin-layout">
      <nav className="bg-background border-b border-border">
        <div className="px-6 py-4 flex items-center justify-between">
          <h1 className="font-heading text-2xl tracking-tight">Pure Atelier Admin</h1>
          <div className="flex items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="gap-2">
                  <Globe className="w-4 h-4" />
                  {i18n.language === 'lv' ? 'LV' : 'RU'}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => changeLanguage('ru')}>
                  Русский
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => changeLanguage('lv')}>
                  Latviešu
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            
            <Button
              variant="outline"
              onClick={handleLogout}
              className="uppercase tracking-widest"
              data-testid="admin-logout-button"
            >
              <LogOut className="w-4 h-4 mr-2" />
              {t('admin.logout')}
            </Button>
          </div>
        </div>
      </nav>

      <div className="flex">
        <aside className="w-64 min-h-screen bg-background border-r border-border p-6">
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-sm font-body text-sm uppercase tracking-wide transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'hover:bg-muted'
                  }`}
                  data-testid={`admin-nav-${item.label.toLowerCase()}`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </aside>

        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
